<template>
  <div>
    <div style="display:flex;margin-top: 15px;">
      <span>开始时间：</span>
      <time-picker :endTime="new Date().getFullYear()" :disabledConfig="timeDisplayFirst" :date="timeRange[0]"></time-picker>
    </div>
    <div style="display:flex;margin-top: 15px;">
      <span>结束时间：</span>
      <time-picker :endTime="new Date().getFullYear()" :disabledConfig="timeDisplaySecond" :date="timeRange[1]"></time-picker>
    </div>
  </div>
</template>

<script>
//
import timePicker from "./dateTimePicker.vue";
export default {
  name: "dateTimePickerRange",
  props: ['timeRange'],
  computed: {
    timeDisplayFirst() {
      let timeDisplay = {
        yearDisabled: false,
        monthDisabled: false,
        dayDisabled: false,
      }
      if(!this.timeRange[0].yearSelect) {
        timeDisplay.monthDisabled = true
      }
      if(!this.timeRange[0].monthSelect) {
        timeDisplay.dayDisabled = true
      }
      return timeDisplay
    },
    timeDisplaySecond() {
      let timeDisplay = {
        yearDisabled: false,
        monthDisabled: false,
        dayDisabled: false,
      }
      if(!this.timeRange[0].yearSelect) {
        this.timeRange[1].yearSelect = ""
        this.timeRange[1].monthSelect = ""
        this.timeRange[1].daySelect = ""
        this.timeRange[1].yearSelect = ""
        timeDisplay.yearDisabled = true
      }
      if(!this.timeRange[1].yearSelect) {
        timeDisplay.monthDisabled = true
      }
      if(!this.timeRange[1].monthSelect) {
        timeDisplay.dayDisabled = true
      }
      return timeDisplay
    }
  },
  watch: {

  },
  data() {
    return {

    }
  },
  components: {
    timePicker
  }
}
</script>

<style scoped>

</style>